import React from 'react';
import { Root, createRoot } from 'react-dom/client';

import { EdgePill, EdgePillProps } from './EdgePill';

const CONTAINER_ID = 'login-modal-autotest-edge-pill';

let root: Root | null = null;

export function showEdgePill(props: EdgePillProps): void {
  if (!root) {
    document.getElementById(CONTAINER_ID)?.remove();
    const container = document.createElement('div');
    container.id = CONTAINER_ID;
    document.body.appendChild(container);
    root = createRoot(container);
  }
  root.render(<EdgePill {...props} />);
}

export function hideEdgePill(): void {
  root?.unmount();
  root = null;
  document.getElementById(CONTAINER_ID)?.remove();
}
